module.exports = __webpack_public_path__ + "media/images/logos/Royal-Holloway-University-of-London-0e523a6160e524c1ba24e2f9fcb2f8c1.svg";